  import { Routes } from '@angular/router';
  import { AboutComponent } from './components/views/technician/about/about.component';
  import { LoginComponent } from './components/views/core/login/login.component';
  import { AuthCallbackComponent } from './components/views/core/auth-callback/auth-callback.component';
  import { HomeComponent } from './components/views/technician/home/home.component';
  import { EquipmentComponent } from './components/views/technician/equipment/equipment.component';
  import { TokenErrorPageComponent } from './components/generic/token-error-page/token-error-page.component';
  import { authGuard } from './auth.guard';
  import { DashboardComponent } from './components/views/admin/dashboard/dashboard.component';
  import { ResourceDatabaseComponent } from './components/views/admin/resource-database/resource-database.component';
  import { StatisticsComponent } from './components/views/admin/statistics/statistics.component';
  import { VideoListComponent } from './components/views/technician/video/video-list/video-list.component';
  import { VideoPlayerComponent } from './components/views/technician/video/video-player/video-player.component';


  export const routes: Routes = [
    {
      path: '',
      component: LoginComponent,
    },
    {
      path: 'login',
      component: LoginComponent,
    },
    {
      path: 'auth/callback',
      component: AuthCallbackComponent,
    },
    {
      path: 'technician',
      children: [
        {
          path: '',
          redirectTo: 'home',
          pathMatch: 'full',
        },
        {
          path: 'home',
          component: HomeComponent,
          resolve: { authGuard },
        },
        {
          path: 'equipment',
          component: EquipmentComponent,
        },
        { 
          path: 'error', 
          component: TokenErrorPageComponent 
        },
        {
          path: 'about',
          component: AboutComponent,
          resolve: { authGuard },
        },
        {
          path: 'video-list',
          component: VideoListComponent,
        },
        {
          path: 'video-player',
          component: VideoPlayerComponent,
        }
      ],
    },
    {
      path: 'admin',
      resolve: { authGuard },
      children: [
        {
          path: 'dashboard',
          component: DashboardComponent,
        },
        {
          path: 'resource-database',
          component: ResourceDatabaseComponent,
        },
        {
          path: 'statistics',
          component: StatisticsComponent,
        },
      ],
    },
    {
      path: '**',
      redirectTo: '',
    }
  ];